const pbdsListProductsLeads = {
    init()
    {

		$('.pbds-list--products-leads .grid').on('click',function(e)
		{
			e.preventDefault();
			window.location.href='#formLeads';
		});

	}
}
window.initializeComponent.push({ component: "pbds-list--products-leads", init: pbdsListProductsLeads.init });

export default() => {
    pbdsListProductsLeads.init();
}